/**
 * Cashback service LetyShops
 *
 * Declares a single web-accessible-resource entry, `images/btn/*.png`, matched to
 * `<all_urls>` with no `use_dynamic_url` — so the whole toolbar-button icon set under
 * `images/btn/` is fetchable from any page at a fixed URL. The `images/btn/` path is
 * distinctive to LetyShops, and images load through `probeImage` with no CORS grant, so
 * detection survives a restrictive page CSP.
 *
 * Manifest verified against version 5.0.10.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lphicbbhfmllgmomkkhjfkpbdlncafbn';

export const letyshops: ExtensionDefinition = {
  id: ID,
  name: 'Cashback service LetyShops',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'One WAR glob (images/btn/*.png) on <all_urls> with no dynamic URL. The btn icon ' +
    'set loads via <img> without a CORS grant, so detection is conclusive and CSP-proof.',
  signals: [
    {
      id: 'war-btn-logo18',
      kind: 'web-accessible-resource',
      description:
        'Load images/btn/logo18.png via <img> — a toolbar-button icon exposed to every ' +
        'origin under the vendor-specific images/btn/ path; needs no CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/btn/logo18.png'),
    },
    {
      id: 'war-btn-logo18-green',
      kind: 'web-accessible-resource',
      description:
        'Load images/btn/logo18green.png via <img> — a second button-state icon that ' +
        'corroborates the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/btn/logo18green.png'),
    },
    {
      id: 'war-btn-logo65',
      kind: 'web-accessible-resource',
      description:
        'Load images/btn/logo65.png via <img> — the larger logo variant, an independent ' +
        'third path in the same exposed folder.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/btn/logo65.png'),
    },
  ],
};
